import { FacebookFilled, TwitterOutlined, SendOutlined, LinkedinFilled, InstagramFilled } from '@ant-design/icons';
import { Button, ButtonProps, message } from 'antd';
import 'src/styles/common/share-button.scss';

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const ShareOnButton = () => null;

const ShareOnFacebook = ({
  url = '',
  text = '',
  ...props
}: { 
  url: string;
  text?: string;
} & ButtonProps) => {
  const shareOnFacebook = () => {
    const encodedUrl = encodeURIComponent(url);
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;

    if (text && navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        message.success("Matn nusxalandi! Facebookda ulashishingiz mumkin.");
        window.open(shareUrl, '_blank');
      }).catch(() => {
        window.open(shareUrl, '_blank');
      });
    } else {
      window.open(shareUrl, '_blank');
    }
  };

  return (
    <Button
      className="share-btn share-btn--facebook"
      icon={<FacebookFilled />}
      shape="circle"
      onClick={shareOnFacebook}
      {...props}
    />
  );
};

const ShareOnTwitter = ({
  url = '',
  text = '',
  ...props
}: {
  url: string;
  text?: string;
} & ButtonProps) => {
  const shareOnTwitter = () => {
    const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      text
    )}&url=${encodeURIComponent(url)}`;
    window.open(shareUrl, '_blank');
  };

  return (
    <Button
      className="share-btn share-btn--twitter"
      icon={<TwitterOutlined />}
      shape="circle"
      onClick={shareOnTwitter}
      {...props}
    />
  );
};

const ShareOnTelegram = ({
  url = '',
  text = '',
  ...props
}: {
  url: string;
  text?: string;
} & ButtonProps) => {
  const shareOnTelegram = () => {
    const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(
      url
    )}&text=${encodeURIComponent(text)}`;
    window.open(shareUrl, '_blank');
  };

  return (
    <Button
      className="share-btn share-btn--telegram"
      icon={<TelegramIcon />}
      shape="circle"
      onClick={shareOnTelegram}
      {...props}
    />
  );
};

const ShareOnLinkedIn = ({
  url = '',
  text = '',
  ...props
}: {
  url: string;
  text?: string;
} & ButtonProps) => {
  const shareOnLinkedIn = () => {
    const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    
    if (text && navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        message.success("Matn nusxalandi! LinkedIn'da ulashishingiz mumkin.");
        window.open(shareUrl, '_blank');
      }).catch(() => {
        window.open(shareUrl, '_blank');
      });
    } else {
      window.open(shareUrl, '_blank');
    }
  };

  return (
    <Button
      className="share-btn share-btn--linkedin"
      icon={<LinkedinFilled />}
      shape="circle"
      onClick={shareOnLinkedIn}
      {...props}
    />
  );
};

const ShareOnInstagram = ({
  url = '',
  text = '',
  ...props
}: {
  url: string;
  text?: string;
} & ButtonProps) => {
  const shareOnInstagram = () => {
    // Instagram doesn't support sharing links via URL directly for posts.
    // We copy the text (if provided) or URL to clipboard and notify the user.
    const contentToCopy = text || url;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(contentToCopy).then(() => {
        message.success("Matn nusxalandi! Instagramda ulashishingiz mumkin.");
        window.open(`https://www.instagram.com/`, '_blank');
      }).catch(() => {
        window.open(`https://www.instagram.com/`, '_blank');
      });
    } else {
      window.open(`https://www.instagram.com/`, '_blank');
    }
  };

  return (
    <Button
      className="share-btn share-btn--instagram"
      icon={<InstagramFilled />}
      shape="circle"
      onClick={shareOnInstagram}
      {...props}
    />
  );
};

ShareOnButton.Facebook = ShareOnFacebook;
ShareOnButton.Twitter = ShareOnTwitter;
ShareOnButton.Telegram = ShareOnTelegram;
ShareOnButton.LinkedIn = ShareOnLinkedIn;
ShareOnButton.Instagram = ShareOnInstagram;

export default ShareOnButton;
